import { useId } from "react"
import { Checkbox } from "@/shared/ui/checkbox"
import { Field } from "@/shared/ui/form-field"
import { DurationInputs } from "./duration-inputs"
import type { Config } from "./editor-props"
import { withField } from "./editor-props"
import type { DurationDraft } from "./lib/duration-draft"

/** Таймаут ожидания: без него бот ждёт ответа сколько угодно. */
export function TimeoutField({
	config,
	onChange,
	what,
}: {
	config: Config
	onChange: (next: Config) => void
	what: string
}) {
	const id = useId()
	const timeout = config.timeout as DurationDraft | undefined
	return (
		<Field
			label="Если не ответил"
			hint={
				timeout
					? "По истечении времени бот пойдёт по выходу «Не ответил», например, напомнит."
					: `Без таймаута бот ждёт ${what} сколько угодно.`
			}
		>
			<label className="flex items-center gap-2 text-sm" htmlFor={id}>
				<Checkbox
					id={id}
					checked={!!timeout}
					onCheckedChange={(checked) =>
						onChange(
							withField(
								config,
								"timeout",
								checked === true ? { amount: 1, unit: "hours" } : undefined,
							),
						)
					}
				/>
				Ждать ограниченное время
			</label>
			{timeout ? (
				<DurationInputs
					label="Таймаут"
					value={timeout}
					onChange={(next) => onChange({ ...config, timeout: next })}
				/>
			) : null}
		</Field>
	)
}
